import type { PrivateEventLocationInput } from '../../api/private-event-update';

import type { PrivateEventFormFields as Fields } from './private-event-form-state';

/** Exactly one location shape goes to the server. A partner venue sends no
 *  region: the server takes it from the venue. */
export function buildLocationInput(
  f: Fields,
  options: { addressLine2?: boolean } = {},
): PrivateEventLocationInput {
  if (f.locationMode === 'venue') return { venueId: f.venueId };
  if (f.locationMode === 'tbd') {
    return { locationTbd: true, regionId: f.regionId, timeZone: f.timeZone };
  }
  return {
    regionId: f.regionId,
    locationName: f.locationName.trim(),
    addressLine1: f.addressLine1.trim(),
    ...(options.addressLine2 ? { addressLine2: f.addressLine2.trim() || null } : {}),
    city: f.city.trim(),
    state: f.state,
    zipCode: f.zipCode.trim(),
    timeZone: f.timeZone,
  };
}
